export const environment = {
  production: true,
  hmr       : false,
  firebaseConfig:{
    apiKey: "AIzaSyAGV6ot7rH1wTmpPWtItTSiKn2KikfdxVI",
    authDomain: "sbccv-proj.firebaseapp.com",
    databaseURL: "https://sbccv-proj.firebaseio.com",
    projectId: "sbccv-proj",
    storageBucket: "sbccv-proj.appspot.com",
    messagingSenderId: "161643941889",
    appId: "1:161643941889:web:11182cc7306cc6d1"
  }
};